import React from 'react';

import PayLaterFeedback from '.';
import NamedAvater from '../../common/NamedAvatar/index.troy';

import logo from '../../../assets/img/logos/troy/troy_weiss.png';

const AvatarComponent = (props) => <NamedAvater {...props} />;

export default (props) => (
  <PayLaterFeedback {...props} avatarComponent={AvatarComponent} logo={logo} />
);
